<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'common.info-concept'">Información sobre el concepto</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-modal__form-container-extend">
      <field-type-rich-text
        [field]="{description: conceptInfo.description}">
      </field-type-rich-text>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleAccept()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'">_Cerrar</span>
    </button>
  </div>
</div>
